export default {
  getInvitation: {
    method: 'GET',
    url: 'invitations/:id',
  },
};
